import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-data-table-shell',
  standalone: true,
  template: `
    <section class="data-table-shell">
      @if (isLoading) {
        <ng-content select="[dataShellLoading]" />
      } @else if (hasError) {
        <ng-content select="[dataShellError]" />
      } @else if (isEmpty) {
        <ng-content select="[dataShellEmpty]" />
      } @else {
        <ng-content />
      }
    </section>
  `,
  styles: [`
    .data-table-shell {
      width: 100%;
      min-width: 0;
      display: block;
    }
  `],
})
export class DataTableShellComponent {
  @Input() public isLoading = false;
  @Input() public hasError = false;
  @Input() public isEmpty = false;
}

